import {PricingItem} from "./pricing-item";
import {Article} from "./article";

export class OptionPricingItem extends PricingItem {
    public option?: Article;
}
